import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import {
     ContentRightWr,
     MainLeftTitle,
     CreateButton,
} from "../../../_uiComponents/WrapperComponents";
import AreaManagementGrid from "./views/AreaManagementGrid";
import { contextApiActions } from "../../../../_redux/_constants";
import { Context } from "../../../../_context/Store";
import AddAreaForm from "./forms/AddArea";

export default function AreaManagementWrapper() {
     const navigate = useNavigate();

     return (
          <>
               <MainLeftTitle title="Area Management">
                    <CreateButton
                         name="Add Area"
                         onClick={() => navigate("/app/area-data-manage/add")}
                    />
               </MainLeftTitle>

               <AreaManagementGrid />
          </>
     );
}